import { Checkbox } from "@progress/kendo-react-inputs";

function ShowCell({ dataItem, hidden, onChange }) {

    function handleChange(event) {
        onChange(event, dataItem.id);
    }

    return (
        <td style={{ width: "30px" }}>
            <Checkbox
                disabled={hidden}
                onClick={handleChange}
                checked={dataItem.show}
            />
        </td>
    );
}

export default ShowCell;